import React from 'react'

const Store = React.lazy(() => import('pages/Store/Store'));
const StoreAdd = React.lazy(() => import('pages/Store/StoreAdd'));
const StoreEdit = React.lazy(() => import('pages/Store/StoreEdit'));
const StoreDetail = React.lazy(() => import('pages/Store/StoreDetail'));

const StoreRoutes = [
    {
        path: '/store',
        exact: true,
        name: 'Danh sách trung tâm/cửa hàng/shop',
        function: 'MD_STORE_VIEW',
        component: Store,
    },
    {
        path: '/store/add',
        exact: true,
        name: 'Thêm mới trung tâm/cửa hàng/shop',
        function: 'MD_STORE_ADD',
        component: StoreAdd,
    },
    {
        path: '/store/detail/:id',
        exact: true,
        name: 'Chi tiết trung tâm/cửa hàng/shop',
        function: 'MD_STORE_VIEW',
        component: StoreDetail,
    },
    {
        path: '/store/edit/:id',
        exact: true,
        name: 'Chỉnh sửa trung tâm/cửa hàng/shop',
        function: 'MD_STORE_EDIT',
        component: StoreEdit,
    },
]

export default StoreRoutes
